import {
    faAddressBook,
    faAddressCard,
    faAlignJustify,
    faAllergies,
    faAmbulance,
    faArrowDown,
    faArrowFromBottom,
    faArrowFromLeft,
    faArrowFromRight,
    faArrowFromTop,
    faArrowLeft,
    faArrowRight,
    faArrowsV,
    faArrowToBottom,
    faArrowToLeft,
    faArrowToRight,
    faArrowToTop,
    faArrowUp,
    faAt,
    faBacteria,
    faBalanceScaleRight,
    faBallotCheck,
    faBan,
    faBandAid,
    faBarcodeRead,
    faBarcodeScan,
    faBars,
    faBatteryBolt,
    faBatteryEmpty,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatterySlash,
    faBatteryThreeQuarters,
    faBed,
    faBell,
    faBellOn,
    faBirthdayCake,
    faBookOpen,
    faBoxAlt,
    faBoxFull,
    faBoxOpen,
    faBriefcase,
    faBriefcaseMedical,
    faBuilding,
    faBullseye,
    faCalendar,
    faCalendarPlus,
    faCalendarTimes,
    faCapsules,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faCaretUp,
    faChartBar,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChevronDoubleDown,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDoubleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faClipboard,
    faClipboardCheck,
    faClipboardList,
    faClipboardListCheck,
    faClipboardPrescription,
    faClock,
    faClone,
    faCloudDownload,
    faCloudUpload,
    faCodeBranch,
    faCodeMerge,
    faCog,
    faCogs,
    faComment,
    faCommentExclamation,
    faCommentLines,
    faComments,
    faCommentSlash,
    faCreditCard,
    faCross,
    faDatabase,
    faDiagnoses,
    faDisease,
    faDollarSign,
    faDolly,
    faDotCircle,
    faEdit,
    faEllipsisH,
    faEllipsisHAlt,
    faEllipsisV,
    faEllipsisVAlt,
    faEnvelope,
    faEnvelopeOpenText,
    faEquals,
    faExchange,
    faExclamation,
    faExclamationCircle,
    faExclamationSquare,
    faExclamationTriangle,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFarm,
    faFax,
    faFemale,
    faFile,
    faFileAlt,
    faFileArchive,
    faFileCode,
    faFileCsv,
    faFileExcel,
    faFileExport,
    faFileImage,
    faFileImport,
    faFileInvoice,
    faFileInvoiceDollar,
    faFilePdf,
    faFileUpload,
    faFilter,
    faFlask,
    faFolder,
    faFolderOpen,
    faFolderTree,
    faGamepad,
    faGlasses,
    faHandHoldingMedical,
    faHandHoldingUsd,
    faHandHoldingWater,
    faHashtag,
    faHdd,
    faHeadSideBrain,
    faHeart,
    faHeartbeat,
    faHistory,
    faHospital,
    faHospitalUser,
    faHourglass,
    faHourglassHalf,
    faIdBadge,
    faInbox,
    faInfo,
    faInfoCircle,
    faKey,
    faLeafHeart,
    faLink,
    faList,
    faLightbulbExclamation,
    faLock,
    faLockOpen,
    faLongArrowDown,
    faLongArrowLeft,
    faLongArrowRight,
    faLongArrowUp,
    faMale,
    faMap,
    faMapMarker,
    faMapMarkerCheck,
    faMapMarkerEdit,
    faMapMarkerPlus,
    faMapSigns,
    faMegaphone,
    faMicrophone,
    faMinus,
    faMinusCircle,
    faMobile,
    faMoneyBillWave,
    faNewspaper,
    faNotEqual,
    faNotesMedical,
    faPaperPlane,
    faPause,
    faPauseCircle,
    faPenAlt,
    faPencil,
    faPencilAlt,
    faPhone,
    faPills,
    faPlay,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPowerOff,
    faPrescription,
    faPrescriptionBottle,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faQuoteRight,
    faReceipt,
    faRedo,
    faSave,
    faSearch,
    faSearchDollar,
    faSearchMinus,
    faSearchPlus,
    faSeedling,
    faShare,
    faShareAlt,
    faShieldCheck,
    faShoppingBasket,
    faShoppingCart,
    faSignIn,
    faSignOut,
    faSlidersH,
    faSortAlt,
    faSparkles,
    faSquare,
    faStar,
    faStarExclamation,
    faStarShooting,
    faStethoscope,
    faStickyNote,
    faStopwatch,
    faSync,
    faSyringe,
    faTable,
    faTablet,
    faTabletAndroidAlt,
    faTachometer,
    faTag,
    faTags,
    faTasks,
    faTh,
    faThermometer,
    faThermometerThreeQuarters,
    faThLarge,
    faThList,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faTint,
    faTombstone,
    faToolbox,
    faTooth,
    faTrash,
    faTrashAlt,
    faTruck,
    faUnlink,
    faUser,
    faUserCheck,
    faUserClock,
    faUserInjured,
    faUserMd,
    faUserPlus,
    faUsers,
    faUserSecret,
    faUserShield,
    faUsersMedical,
    faUserTag,
    faUserTimes,
    faVenusMars,
    faVial,
    faVials,
    faWallet,
    faWheelchair,
    faWhistle,
    faWifi,
    faWindowMinimize,
    faWrench,
    faXRay,
} from '../../fortawesome/pro-duotone-svg-icons';
import {faHtml5} from '../../fortawesome/fontawesome-free-brands';

export const fad = {
    faAddressBook,
    faAddressCard,
    faAllergies,
    faAlignJustify,
    faAmbulance,
    faArrowFromBottom,
    faArrowFromLeft,
    faArrowFromRight,
    faArrowFromTop,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowsV,
    faArrowUp,
    faArrowToBottom,
    faArrowToLeft,
    faArrowToRight,
    faArrowToTop,
    faAt,
    faLongArrowLeft,
    faLongArrowRight,
    faLongArrowUp,
    faLongArrowDown,
    faBacteria,
    faBalanceScaleRight,
    faBallotCheck,
    faBan,
    faBandAid,
    faBarcodeRead,
    faBarcodeScan,
    faBars,
    faBatteryBolt,
    faBatteryEmpty,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatterySlash,
    faBatteryThreeQuarters,
    faBed,
    faBell,
    faBellOn,
    faBirthdayCake,
    faBookOpen,
    faBoxAlt,
    faBoxOpen,
    faBoxFull,
    faBriefcase,
    faBriefcaseMedical,
    faBuilding,
    faBullseye,
    faCalendar,
    faCalendarPlus,
    faCalendarTimes,
    faCapsules,
    faCaretDown,
    faCaretLeft,
    faCaretUp,
    faCaretRight,
    faChartBar,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChevronDoubleDown,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDoubleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faClipboard,
    faClipboardCheck,
    faClipboardList,
    faClipboardListCheck,
    faClipboardPrescription,
    faClock,
    faClone,
    faCloudDownload,
    faCloudUpload,
    faCodeBranch,
    faCodeMerge,
    faCog,
    faCogs,
    faComment,
    faCommentExclamation,
    faCommentLines,
    faComments,
    faCommentSlash,
    faCreditCard,
    faCross,
    faDatabase,
    faDiagnoses,
    faDisease,
    faDollarSign,
    faDolly,
    faDotCircle,
    faDownload: faArrowToBottom,
    faEdit,
    faEllipsisH,
    faEllipsisHAlt,
    faEllipsisV,
    faEllipsisVAlt,
    faEnvelope,
    faEnvelopeOpenText,
    faEquals,
    faNotEqual,
    faExclamation,
    faExchange,
    faExclamationCircle,
    faExclamationSquare,
    faExclamationTriangle,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFarm,
    faFax,
    faFemale,
    faFile,
    faFileAlt,
    faFileExcel,
    faFileExport,
    faFileArchive,
    faFileCode,
    faFileCsv,
    faFileImage,
    faFileImport,
    faFilePdf,
    faFileInvoiceDollar,
    faFileInvoice,
    faFileUpload,
    faFilter,
    faFlask,
    faFolder,
    faFolderOpen,
    faFolderTree,
    faGamepad,
    faGlasses,
    faHandHoldingUsd,
    faHandHoldingWater,
    faHandHoldingMedical,
    faHashtag,
    faHeadSideBrain,
    faHeart,
    faHeartbeat,
    faHdd,
    faHistory,
    faHospital,
    faHospitalUser,
    faHourglass,
    faHourglassHalf,
    faHtml5,
    faIdBadge,
    faInbox,
    faInfo,
    faInfoCircle,
    faKey,
    faLeafHeart,
    faLock,
    faLockOpen,
    faLink,
    faUnlink,
    faList,
    faLightbulbExclamation,
    faMap,
    faMapMarker,
    faMapMarkerCheck,
    faMapMarkerEdit,
    faMapMarkerPlus,
    faMapSigns,
    faMale,
    faMegaphone,
    faMicrophone,
    faMinus,
    faMinusCircle,
    faMobile,
    faMoneyBillWave,
    faNewspaper,
    faNotesMedical,
    faPaperPlane,
    faPause,
    faPauseCircle,
    faPenAlt,
    faPencil,
    faPencilAlt,
    faPhone,
    faPills,
    faPlay,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faPowerOff,
    faPrescriptionBottle,
    faPrescription,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faQuoteRight,
    faReceipt,
    faRedo,
    faSave,
    faSearch,
    faSearchDollar,
    faSearchMinus,
    faSearchPlus,
    faSeedling,
    faSignIn,
    faSignOut,
    faShieldCheck,
    faShoppingBasket,
    faShoppingCart,
    faShare,
    faShareAlt,
    faSlidersH,
    faSortAlt,
    faSparkles,
    faSquare,
    faStar,
    faStarExclamation,
    faStarShooting,
    faStethoscope,
    faStickyNote,
    faStopwatch,
    faSync,
    faSyringe,
    faTable,
    faTablet,
    faTabletAndroidAlt,
    faTachometer,
    faTag,
    faTags,
    faTasks,
    faThermometer,
    faThermometerThreeQuarters,
    faTh,
    faThLarge,
    faThList,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faTint,
    faToolbox,
    faTooth,
    faTombstone,
    faTrash,
    faTrashAlt,
    faTruck,
    faUser,
    faUserCheck,
    faUserClock,
    faUserInjured,
    faUserMd,
    faUserPlus,
    faUsers,
    faUsersMedical,
    faUserSecret,
    faUserShield,
    faUserTag,
    faUserTimes,
    faWheelchair,
    faVenusMars,
    faVial,
    faVials,
    faXRay,
    faWallet,
    faWhistle,
    faWifi,
    faWindowMinimize,
    faWrench,
};
